/**
 * External Dependencies
 */
import 'jquery';

import './locomotive/app';

$(() => {
  if($('.b-relation-pages_wrap .c-card.-page-round').length) {
    $('.b-relation-pages_wrap .c-card.-page-round .before').each(function() {
      var $width = $(this).parents('.c-card_image').outerWidth();
      $(this).css('border-width', 'calc('+$width+'px / 2)');
    });
  }
  $(window).resize(function() {
    if($('.b-relation-pages_wrap .c-card.-page-round').length) {
      $('.b-relation-pages_wrap .c-card.-page-round .before').each(function() {
        var $width = $(this).parents('.c-card_image').outerWidth();

        $(this).css('border-width', 'calc('+$width+'px / 2)');
      });
    }
  });
});
